import { Injectable } from '@angular/core';

import { ListResponse } from '../../models/list-response';
import { StaffNote, StaffNoteFilters } from '../../models/staff-note';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class StaffNoteService {
  /**
   * A service providing access to staff notes via the API.
   */

  constructor(
    private apiService: ApiService
  ) {}

  /**
   * Get a page of staff notes from the API.
   *
   * @param pageNumber - The requested page number.
   * @param pageSize - The requested number of notes per page.
   * @param filters - The set of filters to apply to the notes.
   * @return The list of notes.
   */
  getStaffNotes(pageNumber?: number,
                pageSize?: number,
                filters?: StaffNoteFilters): Promise<ListResponse<StaffNote>> {
    return this.apiService.getCollection<StaffNote, StaffNoteFilters>(
      'staff-notes/',
      pageNumber,
      pageSize,
      filters
    );
  }

  /**
   * Post a new staff note to the API.
   *
   * @param staffNote - The new staff note to create.
   * @return The new staff note returned from the API.
   */
  addStaffNote(staffNote: StaffNote): Promise<StaffNote> {
    return this.apiService.postToAPI<StaffNote>(
      'staff-notes/',
      staffNote
    );
  }

  /**
   * Update a staff note by making a PUT request to the API.
   *
   * @param staffNote - The staff note, with updated values.
   * @return The updated staff note returned from the API.
   */
  updateStaffNote(staffNote: StaffNote): Promise<StaffNote> {
    return this.apiService.putToAPI<StaffNote>(
      staffNote.url,
      staffNote
    );
  }
}
